import { createFileRoute, notFound } from "@tanstack/react-router";

import { workspacesQueries } from "@/api/resources/workspaces/queries";
import WorkspaceCustomersPage from "@/components/WorkspaceCustomer/WorkspaceCustomersPage";
import i18n from "@/providers/i18n";
import Icon from "@/utils/icons";

import type { BreadcrumbsContext } from "@/providers/routerConfig";

export const Route = createFileRoute("/_auth/workspaces/$workspace_id/customer-workspaces/")({
  beforeLoad: () => {
    const breadcrumbs: BreadcrumbsContext[] = [
      {
        label: i18n.t("navigation.workspace"),
        icon: <Icon.WORKSPACE />,
        path: "/workspaces/$workspace_id",
      },
      {
        label: i18n.t("navigation.customer-workspaces"),
        icon: <Icon.CUSTOMER_WORKSPACES />,
      },
    ];
    return { breadcrumbs };
  },
  loader: async ({ context, params: { workspace_id } }) => {
    const currentWorkspace = await context.queryClient.ensureQueryData(workspacesQueries.byId(workspace_id));
    if (!currentWorkspace) throw notFound();
    await context.queryClient.ensureQueryData(workspacesQueries.listCustomerWorkspaces(workspace_id));
  },
  component: WorkspaceCustomersPage,
});
